import { type Common } from './common.js';
import type * as AgenticPlatform from './models/agenticPlatform.js';

export class API {
  common: Common;
  readonly baseEndpoint = '/agentic-platform/sessions';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<AgenticPlatform.AgenticPlatformSession[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.getJSON(url);
  }

  async create(
    values: AgenticPlatform.CreateAgenticPlatformSessionValues
  ): Promise<AgenticPlatform.AgenticPlatformSession> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(args: {
    sessionId: string;
    values: AgenticPlatform.UpdateAgenticPlatformSessionValues;
  }): Promise<AgenticPlatform.AgenticPlatformSession> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(args.sessionId)}`
    );
    return await this.common.patchJSON(url, args.values);
  }

  async delete(sessionId: string): Promise<{ id: string }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${encodeURIComponent(sessionId)}`);
    return await this.common.deleteJSON(url);
  }

  async findAllMessages(sessionId: string): Promise<AgenticPlatform.AgenticPlatformMessage[]> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(sessionId)}/messages`
    );
    return await this.common.getJSON(url);
  }
}
